import script from "./TTextElement.vue?vue&type=script&lang=js"
export * from "./TTextElement.vue?vue&type=script&lang=js"

import "./TTextElement.vue?vue&type=style&index=0&id=3ee2426b&lang=scss"

const __exports__ = script;

export default __exports__